class AccOrdion extends HTMLElement {
  constructor() {
    super();

    const triggers = Array.from(this.querySelectorAll('.accordion__trigger'))

    if(triggers && triggers.length > 0) {
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleClick)
      })
    }

  }

  handleClick(event) {

    const wrapper = this.closest('.accordion')

    wrapper.classList.toggle('is-opened')

    const content = wrapper.querySelector('.accordion__content')

    if (content.style.maxHeight) content.style.maxHeight = null
    else content.style.maxHeight = content.scrollHeight + 'px'

  }
}
customElements.define('acc-ordion', AccOrdion);